module.exports = __webpack_public_path__ + "images/apple-touch-icon-144x144.08e5305fc552e7929b1560292d68891f.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-144x144.png
// module id = 990
// module chunks = 0